import TextFieldComponent from '@components/inputs/textField/TextField.component';
import ModalComponent from '@components/modal/Modal.component';
import { Button, Stack } from '@mui/material';
import { templatesService } from '@store/audits/templates/templates.service';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface NewTemplateProps {
  handleClose: () => void;
  auditId?: number;
}

const NewTemplate = (props: NewTemplateProps) => {
  const { handleClose, auditId } = props;
  const [title, setTitle] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();


  const handleCreateTemplate = (name: string) => {
    if (auditId) {
      templatesService.createTemplate({ auditId, name }).subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
        complete: () => {
          enqueueSnackbar('Votre template a été créé avec succès!', { variant: 'success' });
          handleClose();
        },
      });
    }
  };

  return (
    <ModalComponent
      handleClose={handleClose}
      title={t('audits.modals.newTemlpate.title')}
      content={(
        <Stack width="70%" spacing={3} pt="55px" pb="10px">
          <TextFieldComponent
            color="secondary"
            labelWidth={160}
            label={t('audits.modals.newTemlpate.titleTemplate')}
            placeholder={t('audits.modals.newTemlpate.titleTemplate')}
            handleChange={setTitle}
            value={title}
          />
        </Stack>
      )}
      actions={(
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleCreateTemplate(title)}>
          {t('global.add')}
        </Button>
      )} />
  );
};

export default NewTemplate;
